import { StateType } from 'typesafe-actions'
import { ApexCash, ApexAccounts, ApexAuth, ApexProviders } from 'apex-ui-services'
import { all } from 'redux-saga/effects'
import createSagaMiddleware from 'redux-saga'
import { applyMiddleware, compose, createStore } from 'redux'
import { apexMenuSagas } from 'apex-online-menu'
import rootReducer from './rootReducer'
import { currentUser, legit, session, authorization } from 'apex-legit-service'
import { getAppConfigSetting } from '../utils'

const sagaMiddleware = createSagaMiddleware()

function* rootSaga() {
  const apiUrl: string = getAppConfigSetting('apiUrl')
  yield all([
    ApexCash.achRel.sagas.fetchAllAchRelationshipsFlow(apiUrl),
    ApexCash.amountAvailable.sagas.fetchAmountAvailableFlow(apiUrl),
    ApexCash.achTransfers.sagas.createAchDepositFlow(apiUrl),
    ApexCash.achTransfers.sagas.createAchWithdrawalFlow(apiUrl),
    ApexCash.achTransfers.sagas.cancelAchDepositFlow(apiUrl),
    ApexCash.achTransfers.sagas.cancelAchWithdrawalFlow(apiUrl),
    ApexAccounts.accounts.sagas.searchAccountsFlow(apiUrl),
    ApexAccounts.accounts.sagas.getAccountFlow(apiUrl),
    ApexCash.iraConstraints.sagas.fetchIraConstraintsFlow(apiUrl),
    ApexCash.transfers.sagas.searchTransfersFlow(apiUrl),
    ApexAuth.authorization.sagas.authorizationFlow(apiUrl),
    ApexAuth.loginSso.sagas.ssoLoginFlow(apiUrl),
    ApexAuth.loginType.sagas.loginTypeFlow(apiUrl),
    ApexProviders.margins.sagas.getMarginSummaryFlow(apiUrl),
    authorization.authorizeFlow(),
    currentUser.currentUserFlow(),
    legit.adoptExistingSessionFlow(),
    legit.loginFlow(),
    legit.logoutFlow(),
    session.createSessionFlow(),
    session.destroySessionFlow(),
    ...apexMenuSagas(),
  ])
}

export default function () {
  const hasWindow = typeof window !== 'undefined'
  const composeEnhancers: any = hasWindow
    ? // @ts-ignore
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose
  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)))
  sagaMiddleware.run(rootSaga)
  return store
}

export type Store = StateType<typeof import('./index').default>
export type RootState = StateType<typeof import('./rootReducer').rootReducer>
